// page (네비게이션 단위 업무 그룹)

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역
// common
import UserHome from 'src/com/keymansco/chihuahuaone/page/common/UserHome/UserHome';

// =================================================================================================
// 상수
// =================================================================================================

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  common: {
    // 공통
    UserHome, // 사용자 홈
  },
};
